exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-8695effe]{width:100%;max-width:70px;height:auto;-o-object-fit:contain;object-fit:contain}.payment[data-v-8695effe]{padding:10px}.payment[data-v-8695effe]:not(:last-child){border-bottom:1px solid #e0e0e0}\n", ""]);

// exports
